// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/reducciones-hotels/list',
    name: 'reducciones-hotels-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/nomencladores/hotels/Reducciones.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'nom_reducciones_contrate_hotels',
    },
  },
]

export default formTable
